import getActionsByDocument from '../../../../components/comments/actions';

const DOCUMENT = 'TALENT_COMMENTS_';

export default getActionsByDocument(DOCUMENT);
